import React, { useEffect, useState } from 'react';
import FlyBtn from './FlyBtn';
import { BASE_URL, IMAGE_URL, priceunit } from '../../Components/client-config';
import { connect, useSelector } from 'react-redux';
import mergn from 'mergn-webapp-sdk'
import { toast } from 'react-toastify';
import { favouriteAdd } from '../../Redux/actions/customer';
import useTrackEvent from '../../hooks/useTrackHook';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { itemReady } from '../../utils/productValidations';

function ManuCard(props: any) {
  const isLogged = useSelector((state: any) => state.customer.isLogged);
  const [fav, setFav] = useState(false);
  const [disable, setDisable] = useState(false);
  const [addEvent] = useTrackEvent();
  const { t } = useTranslation();

  const handleFavourite = (alreadyFav: any, id: any, type: any,product_name:any) => {
    if (!isLogged) {
      toast.error(t("SIGNIN_TO_FAVORITE"))
      return;
    }
    if (alreadyFav || fav) return;
    let data: any = {};
    let windowObj = (window as any)
    windowObj.dataLayer.push({ ecommerce: null });
    data.product = product_name;
    if (type == "combo") {
      data.combo_id = id
      props.favouriteAdd(data, setFav)
      windowObj.dataLayer.push({
        'event': 'add_to_wishlist',
        'ecommerce': {
          currency: 'PKR',
          items: [
            {
              item_id: id,
              item_name: product_name,
              price: props.item.combo_mrp_price,
            }
          ]
        }
      });
      addEvent({category:"events",events:`${product_name} add to Fav`})
    }
    else {
      data.menu_item_id = id
      props.favouriteAdd(data, setFav)
      windowObj.dataLayer.push({
        'event': 'add_to_wishlist',
        'ecommerce': {
          currency: 'PKR',
          items: [
            {
              item_id: id,
              item_name: product_name,
              price: props.item.item_size[0].mrp,
            }
          ]
        }
      });
    }
  }

  const handleEvent = (product: any) => {

    const makeItem = {
      name: product.combo_name ? product.combo_name : product.item_name,
      price: product.combo_name ? product.combo_mrp_price : product.item_size[0].mrp,
      category: product?.item_group_id ? product?.item_group_id?.group_name : product.group_id?.group_name,
      url : {
          page: `${BASE_URL}menu#${product.combo_id ? 'combo' : 'item'}/${product.combo_name ? product.combo_name.replace(/\s+/g, '') :  product.item_name.replace(/\s+/g, '')}_${product.combo_id ? product.combo_id : product.menu_item_id }`,
          product: `${IMAGE_URL}${product.combo_name ? product.image_url : product.item_size[0].image_url}`
      }
    }

    mergn.recordEvent("Product Click", [
      { eventProperty: 'product-name', value: makeItem.name },
      { eventProperty: 'product-price', value: makeItem.price },
      { eventProperty: 'category-name', value: makeItem.category },
      { eventProperty: 'product-page-url', value: makeItem.url.page },
      { eventProperty: 'product-image-url', value: makeItem.url.product }
    ])

    props.selectedItem(product)

  }

  useEffect(() => {
    if (!props?.item?.is_publish || props?.item?.is_snooze || props?.item?.item_close_flag) {
      setDisable(true);
    }
  }, []);
  return (
    <div>

      <div className={`card menu-card ${disable ? "disableShadow" : ""}`}>
        <div className='kfc-box'>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div onClick={() => handleEvent(props.item)} className='manu-img-item'>
          <img 
            className="card-img-top card-img" 
            src={`${IMAGE_URL}${
              props.item.item_size && props.item.item_size.length > 0 ? 
                props.item.item_size[0].image_url 
              :
                props.item.image_url
            }`} 
            alt={
              props.item.item_size && props.item.item_size.length > 0 ?
                props.item.item_size[0].alt_text
              :
                props.item.alt_text
            } 
          />
        </div>
        <div className="card-body p-0">
          <div className='d-flex justify-content-between align-items-center'>
            <h5 className="card-title">
            {
              props.item.combo_name ? props.item.combo_name : props.item.item_name
            }
            </h5>
            <span onClick={() => handleFavourite(props.item.isFav, props.item.combo_id > 0 ? props.item.combo_id : props.item.menu_item_id, props.item.combo_id > 0 ? "combo" : 'item',props.item.combo_id > 0 ? props.item.combo_name : props.item.item_name)} >
              <div>
                {!fav ?
                  <button className='btn-item' > {!props.item.isFav ? <i className="ri-heart-line"></i> : <i className="ri-heart-fill clr-red"></i>}</button> :
                  <button className='btn-item' > <i className="ri-heart-fill clr-red"></i></button>
                }
              </div>
            </span>
          </div>
          <p className="card-text" title={
              props.item.combo_name ?
                props.item.combo_description
              :
                props.item.item_size[0].description
            }>
            {
              props.item.combo_name ?
                props.item.combo_description
              :
                props.item.item_size[0].description
            }
          </p>

          <h4 className='kfc-price'>
            {priceunit}
            {
              props.item.item_size && props.item.item_size.length > 0 ? 
                props.item.item_size[0].discount_price ? 
                  props.item.item_size[0].discount_price
                :
                  props.item.item_size[0].mrp
              :
                props.item.discount_price ? 
                  props.item.discount_price
                :
                  props.item.combo_mrp_price
            }
          </h4>
          <div className='price-label'> 
            {!disable && <FlyBtn itemReady={itemReady} selectedItem={props.selectedItem} product={props.item} handleAdd={props.handleAdd} />}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch: any) => {
  return {

    favouriteAdd: function (data: any, setState?: any) {
      dispatch(favouriteAdd(data, setState));
    }
  };
};

export default connect(null, mapDispatchToProps)(ManuCard);
